import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminResetPasswordPage from "@/pages/admin/AdminResetPasswordPage";

export const Route = createFileRoute("/_admin/admin/reset-password")({
  head: () => pageHead("Admin Reset Password", "Reset your AKIVA admin password.", "/admin/reset-password", true),
  component: AdminResetPasswordPage,
});
